var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { CircularProgress, Drawer, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { SimpleForm, TextInput, useNotify, useRefresh, useGetOne } from "react-admin";
import { useMutation } from "@apollo/client";
import { INSERT_TENANT } from "../../queries/InsertTenant";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { isNull } from "@sequentech/ui-core";
import { AuthContext } from "@/providers/AuthContextProvider";
export var CreateTenant = function (_a) {
    var isDrawerOpen = _a.isDrawerOpen, setIsDrawerOpen = _a.setIsDrawerOpen;
    var createTenant = useMutation(INSERT_TENANT)[0];
    var notify = useNotify();
    var _b = useState(null), newId = _b[0], setNewId = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var authContext = useContext(AuthContext);
    var t = useTranslation().t;
    var navigate = useNavigate();
    var refresh = useRefresh();
    var _d = useGetOne("sequent_backend_tenant", {
        id: authContext === null || authContext === void 0 ? void 0 : authContext.tenantId,
    }), newTenant = _d.data, isOneLoading = _d.isLoading, error = _d.error;
    useEffect(function () {
        if (isNull(newId)) {
            return;
        }
        if (isLoading && error && !isOneLoading) {
            setIsLoading(false);
            notify(t("tenantScreen.createError"), { type: "error" });
            setIsDrawerOpen(false);
            refresh();
            return;
        }
        if (isLoading && !error && !isOneLoading && newTenant) {
            setIsLoading(false);
            notify(t("tenantScreen.createSuccess"), { type: "success" });
            setIsDrawerOpen(false);
        }
    }, [isLoading, newTenant, isOneLoading, error, newId, refresh, authContext, navigate]);
    var onSubmit = function (_a) {
        var slug = _a.slug;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, data, errors;
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, createTenant({
                            variables: {
                                slug: slug,
                            },
                        })];
                    case 1:
                        _b = _e.sent(), data = _b.data, errors = _b.errors;
                        if ((_c = data === null || data === void 0 ? void 0 : data.insertTenant) === null || _c === void 0 ? void 0 : _c.id) {
                            setNewId((_d = data === null || data === void 0 ? void 0 : data.insertTenant) === null || _d === void 0 ? void 0 : _d.id);
                            setIsLoading(true);
                        }
                        else {
                            notify(t("tenantScreen.createError"), { type: "error" });
                            setIsLoading(false);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return (_jsx(Drawer, __assign({ anchor: "right", open: isDrawerOpen, onClose: function () { return setIsDrawerOpen(false); }, PaperProps: {
            sx: { width: "30%" },
        } }, { children: _jsxs(SimpleForm, __assign({ onSubmit: onSubmit }, { children: [_jsx(Typography, __assign({ variant: "h4" }, { children: "".concat(t("tenantScreen.common.title"), " ").concat(newTenant === null || newTenant === void 0 ? void 0 : newTenant.slug) })), _jsx(Typography, __assign({ variant: "body2" }, { children: t("tenantScreen.new.subtitle") })), _jsx(TextInput, { source: "slug", onKeyDown: function (event) { return event.stopPropagation(); } }), isLoading ? _jsx(CircularProgress, {}) : null] })) })));
};
